"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOARD_LABEL = void 0;
exports.setBoardLabel = setBoardLabel;
// eslint-disable-next-line import/no-mutable-exports
let BOARD_LABEL = exports.BOARD_LABEL = 'Observation Deck';
function setBoardLabel(label) {
  exports.BOARD_LABEL = BOARD_LABEL = label;
}